import * as yup from 'yup'

export default yup.object().shape({
  buildings: yup
    .array()
    .min(1, 'O campo Blocos é requerido.')
    .required('O campo Blocos é requerido.')
})
